import { render } from "./InputFieldComponent.vue?vue&type=template&id=3be38e2c"
import script from "./InputFieldComponent.vue?vue&type=script&lang=js"
export * from "./InputFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__